module.exports = __webpack_public_path__ + "img/DE01409.9cc4c489.png";